<template>
  <component :is="currentComponent" :key="etapeKey" :parcours="parcours" :tag="tag" :data_etape0="data_etape0" :paragraphId="paragraphId" @backToEtape0="loadEtape0" @switchToEtape1="loadEtape1" @switchToEtape2="loadEtape2" @switchToEtape3="loadEtape3" @switchToEtape4="loadEtape4" @switchToEtape5="loadEtape5"  />
</template>

<script setup>
import { defineProps, ref, onMounted, nextTick } from 'vue';
import Etape0Inner from './Etape0Inner.vue';
import Etape1 from './Etape1.vue';
import Etape2 from './Etape2.vue';
import Etape3 from './Etape3.vue';
import Etape4 from './Etape4.vue';
import Etape5 from './Etape5.vue';

const props = defineProps({
  data_etape0: Object,
  paragraphId: Number,
  parcours: Object,
  tag: Object
});

const componentsMap = {
  '1': Etape1,
  '2': Etape2,
  '3': Etape3,
  '4': Etape4,
  '5': Etape5
};


const etapeKey = ref(0);
const params = new URLSearchParams(window.location.search);
const etape = params.get('etape');
const parcoursUrl = params.get('parcours');
const detail = params.get('detail') === 'true'; // Lire le paramètre detail
//console.log('Etape:'+etape);
//console.log('Parcours:'+parcoursUrl);
const error = ref(null);


const currentComponent = ref(Etape0Inner);

const loadEtape1Inner = () => {
  //console.log('Load Etape 1 Inner');
  currentComponent.value = Etape1;
  etapeKey.value++;
};

const loadEtape0 = () => {
  //console.log('Load Etape 0');
  currentComponent.value = Etape0Inner;
  etapeKey.value++;
};


const loadEtape1 = () => {
  etapeKey.value++;
  currentComponent.value = Etape1;
  //console.log('load Etape 1');
};

const loadEtape2 = () => {
  //console.log('Load Etape 2');
  currentComponent.value = Etape2;
  etapeKey.value++;
};

const loadEtape3 = () => {
  //console.log('Load Etape 3');
  currentComponent.value = Etape3;
  etapeKey.value++;
};

const loadEtape4 = () => {
  //console.log('Load Etape 4');
  currentComponent.value = Etape4;
  etapeKey.value++;
};

const loadEtape5 = () => {
  currentComponent.value = Etape5;
  etapeKey.value++;
  const parcoursJson = encodeURIComponent(JSON.stringify(props.parcours));
  const detailParam = props.parcours.detail ? 'true' : 'false';
  console.log(`[Configurateur] URL étape 5 pré-remplie :\n${window.location.origin}${window.location.pathname}?etape=5&parcours=${parcoursJson}&detail=${detailParam}`);
};


defineEmits(['switchToEtape1','switchToEtape2','switchToEtape3','switchToEtape4','switchToEtape5']);

//&parcours={"mobile"%3A0%2C"forfait"%3A0%2C"multiligne"%3A0%2C"connexion"%3A0%2C"livebox"%3A0%2C"multilignes"%3A{"multiligne1"%3A{"forfait"%3A0%2C"who"%3A0}%2C"multiligne2"%3A{"forfait"%3A0%2C"who"%3A0}%2C"multiligne3"%3A{"forfait"%3A0%2C"who"%3A0}%2C"multiligne4"%3A{"forfait"%3A0%2C"who"%3A0}}}
//&parcours={"mobile":0,"forfait":0,"multiligne":0,"connexion":0,"livebox":0,"multilignes":{"multiligne1":{"forfait":0,"who":0},"multiligne2":{"forfait":0,"who":0},"multiligne3":{"forfait":0,"who":0},"multiligne4":{"forfait":0,"who":0}}}
onMounted(async () => {
  //console.log('Etape0 mounted');
  try {

    if (etape && componentsMap[etape]) {
      if (parcoursUrl) {
        Object.assign(props.parcours, JSON.parse(decodeURIComponent(parcoursUrl)));
      }
      props.parcours.etape = parseInt(etape);
      props.parcours.detail = detail; // Ajouter le paramètre detail
      currentComponent.value = componentsMap[etape];
      //console.log(`✅ Etape${etape}.vue trouvé`);
    }
    nextTick(() => {
      setTimeout(() => {
        window.scrollTo({ top: 0 });
      }, 0);
    });
  } catch (e) {
    error.value = e.message;
  }
});


</script>
